export const GET_LIST_THUCHIHOPDONG = "GET_LIST_THUCHIHOPDONG";
export const GET_LIST_THUCHIHOPDONG_SUCCESS = "GET_LIST_THUCHIHOPDONG_SUCCESS";
export const GET_LIST_THUCHIHOPDONG_FAILURE = "GET_LIST_THUCHIHOPDONG_FAILURE";
